const variables = {
  mainNavigationLargeHeight: 88,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'tertiary',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 8,
  mainNavigationSmallMenuButtonPosition: 'start',
  mainNavigationSmallProfileMenuButtonVariant: 'primary',
};

export default variables;
